import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux/store";
import type { AuthSession, AuthUser } from "../types/auth.types";

export type AuthState = {
  accessToken: string | null;
  user: AuthUser | null;
  isHydrated: boolean;
};

const initialState: AuthState = {
  accessToken: null,
  user: null,
  isHydrated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setHydrated: (state, action: PayloadAction<boolean>) => {
      state.isHydrated = action.payload;
    },
    hydrateFromStorage: (state, action: PayloadAction<AuthSession | null>) => {
      state.accessToken = action.payload?.accessToken ?? null;
      state.user = action.payload?.user ?? null;
      state.isHydrated = true;
    },
    setSession: (state, action: PayloadAction<AuthSession>) => {
      state.accessToken = action.payload.accessToken;
      state.user = action.payload.user;
      state.isHydrated = true;
    },
    setUser: (state, action: PayloadAction<AuthUser | null>) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.accessToken = null;
      state.user = null;
      state.isHydrated = true;
    },
  },
});

export const { setHydrated, hydrateFromStorage, setSession, setUser, logout } =
  authSlice.actions;

export default authSlice.reducer;


export const selectAuth = (state: RootState) => state.auth;
export const selectAccessToken = (state: RootState) => state.auth.accessToken;
export const selectAuthUser = (state: RootState) => state.auth.user;
export const selectIsAuthHydrated = (state: RootState) => state.auth.isHydrated;
export const selectIsAuthenticated = (state: RootState) =>
  Boolean(state.auth.accessToken);
